import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import RouteLoader from '../RouteLoader';

// Route guard for /admin/*. This is a UX convenience only - the real
// security boundary is Firestore/Storage rules (firestore.rules,
// storage.rules), which enforce the admin allowlist server-side regardless
// of anything in this component.
const RequireAdmin = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <RouteLoader />;
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
};

export default RequireAdmin;
